import {
  DEFAULT_LISTING_SORT,
  LISTING_SORT_OPTIONS,
  ListingSortOption,
} from 'components/listings/sortListings'
import { useTranslation } from 'react-i18next'

type ListingsSortSelectProps = {
  value: ListingSortOption
  onChange: (value: ListingSortOption) => void
}

const ListingsSortSelect = ({ value, onChange }: ListingsSortSelectProps) => {
  const { t } = useTranslation()

  return (
    <label className="flex items-center gap-2 text-sm text-imovSecondary">
      <span className="shrink-0 font-medium">{t('listing.sort.label')}</span>
      <select
        value={value}
        onChange={e => onChange(e.target.value as ListingSortOption)}
        className="h-9 min-w-0 max-w-[12.5rem] cursor-pointer rounded-lg border border-gray-300 bg-white px-2.5 text-sm text-imovSecondary shadow-sm focus:border-imovPrimary focus:outline-none focus:ring-2 focus:ring-imovPrimary/40 sm:max-w-none"
        aria-label={t('listing.sort.label')}
      >
        {LISTING_SORT_OPTIONS.map(option => (
          <option key={option} value={option}>
            {t(`listing.sort.${option}`)}
          </option>
        ))}
      </select>
    </label>
  )
}

export { DEFAULT_LISTING_SORT }
export default ListingsSortSelect
